// extracted by mini-css-extract-plugin
export var editor = "_11-0";
export var flowSidebar = "_40-2";